import { ChangeDetectorRef, Component, OnInit, signal } from '@angular/core';
import { EstablishmentAllService } from './service/establishment-all.service';
import { BehaviorSubject, Subject, catchError, of, switchMap, takeUntil, tap } from 'rxjs';
import { CreateSlugService } from '../../core/service/create-slug.service';
import { ActivatedRoute, Router } from '@angular/router';
import { EstablishemntsGeneralComponent } from "../establishemnts-general/establishemnts-general.component";
import { EstablishmentsForCategorieData } from '../establishments-for-categorie/interface/establishments-for-categorie.interface';
import { AppState } from '../../store/app.state';
import { Store } from '@ngrx/store';
import { NavigateEstablishment } from '../../core/interfaces/navigate-for-categorie-establishment/navegiate-for-categorie.establishment.service';
import { CategoriesEstablishmentComponent } from "../../shared/components/categories-establishment/categories-establishment.component";
import { CategoriesGralComponent } from "../../shared/components/categories-gral/categories-gral.component";
import { ArrowBackComponent } from "../../shared/components/arrow-back/arrow-back.component";

@Component({
  selector: 'features-establishments-all',
  standalone: true,
  imports: [EstablishemntsGeneralComponent, CategoriesEstablishmentComponent, CategoriesGralComponent, ArrowBackComponent],
  templateUrl: './establishments-all.component.html',
  styleUrl: './establishments-all.component.css'
})
export class EstablishmentsAllComponent implements OnInit {
  establishments = signal<EstablishmentsForCategorieData[]>([]);
  isLoading = signal<boolean>(true);
  establishmentTypeId: number = 0;
  private destroy$ = new Subject<void>();
  private loading = new BehaviorSubject<boolean>(false);
  loading$ = this.loading.asObservable();

  constructor(private establishmentAllService: EstablishmentAllService,
    private createSlugService: CreateSlugService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private store: Store<AppState>
  ) {

  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.establishmentTypeId = +params['id']; // Convert string to number
      this.getEstablishments();
    });
  }
  private createSlug(text: string): string {
    if (!text) return '';
    return this.createSlugService.createSlug(text);
  }

  getEstablishments(): void {
    this.store.select(state => state.location).pipe(
      takeUntil(this.destroy$),
      tap(() => this.isLoading.set(true)),
      switchMap(location => {
        const body: NavigateEstablishment = {
          latitude: location.latitude.toString(),
          longitude: location.longitude.toString()
        };
        return this.establishmentAllService.getEstablishments(body).pipe(
          tap((response) => console.log('Establishments response:', response)),
          catchError((error) => {
            console.error('Error loading establishments:', error);
            return of(null);
          })
        );
      })
    ).subscribe({
      next: (response) => {
        if (response && response.data) {
          this.establishments.set(response.data);
        }
        this.isLoading.set(false);
      },
      error: (err) => {
         console.error('Subscription error:', err);
         this.isLoading.set(false);
      }
    });
  }
  async navigateToProducts(event: { id_restaurant: number, name_restaurant: string }): Promise<void> {


    try {
      this.loading.next(true);
      const slug = this.createSlug(event.name_restaurant);
      await this.router.navigate(['/products-establishment', event.id_restaurant, slug]);
    } catch (error) {
      console.error('Error al navegar a productos:', error);
      // Intento de fallback a la ruta sin slug si falla
      try {
        await this.router.navigate(['/products-establishment', event.id_restaurant]);
      } catch {
        console.error('Falló también la navegación de fallback');
      }
    } finally {
      this.loading.next(false);
      this.cdr.markForCheck();
    }
  }
}
